import DriveHeader from '@/components/DriveHeader.tsx'
import { Loading } from 'react-daisyui'
import { IconCircleCheck } from '@tabler/icons-react'
import { useEffect } from 'react'
import { useDrives } from '@/stores/useDrives.ts'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { captureException } from '@/controller/sentryHelper.ts'
import { useTranslation } from 'react-i18next'

export default function PaymentSuccessPage() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { currentDrive } = useDrives()
  const navigate = useNavigate()
  useEffect(() => {
    const id = setInterval(async () => {
      await queryClient.invalidateQueries({
        queryKey: ['drive', currentDrive!.id],
      })
    }, 1000)

    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    if (!currentDrive!.is_demo) {
      navigate(`/d/${currentDrive!.id}`)
      try {
        console.log('Upgrade Purchase successful')
      } catch (error) {
        captureException(error, 'Tracking upgrade purchase')
      }
    }
  }, [currentDrive!.is_demo]);

  return <div>
    <DriveHeader />
    <div className="container mx-auto flex flex-col gap-3 justify-center items-center py-5">
      <div className='flex flex-row gap-3 items-center font-bold'>
        <IconCircleCheck className='text-primary' size={48} />
        <span className='text-xl'>{t('payment.paymentSuccessful')}</span>
      </div>
      <div className='flex flex-row gap-3 items-center mt-5'>
        <Loading color='primary' /> {t('payment.upgradeBeingProcessed')}
      </div>
    </div>
  </div>
}
